import { render } from "./PageHelpButton.vue?vue&type=template&id=321976eb&scoped=true"
import script from "./PageHelpButton.vue?vue&type=script&lang=js"
export * from "./PageHelpButton.vue?vue&type=script&lang=js"

import "./PageHelpButton.vue?vue&type=style&index=0&id=321976eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321976eb"]])

export default __exports__